module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/12-4aa5d2c97784093607f8427bacb998b4.jpg";